import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { AbstractControl, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { AppGlobals } from '@app/app.global';
import { AuthService, SharedService, User } from '@app/core';
import { first } from 'rxjs/operators';
@Component({
  selector: 'app-forgot-password', // The selector used to identify the component in HTML
  templateUrl: './forgot-password.component.html', // The URL of the component's template file
  styleUrls: ['./forgot-password.component.scss'], // The URLs of the component's style files
  host: {
    style: "display:block;", // Inline style applied to the host element
    class: "loginwrapper", // CSS class added to the host element
    "[attr.tabindex]": "-1", // Binding of the "tabindex" attribute to the value -1
  }
})

export class ForgotPasswordComponent implements OnInit {
  user: User;
  token: string;
  otp: string = '';
  forgotFirstStep = true;
  forgotOtpSection = false;
  passwordSection = false;

  errorMessageForgotPass: string = '';
  forgotForm: FormGroup;
  isSubmitAttempted: boolean = false;
  otpSectionForm: FormGroup;
  disableButtonOnError: boolean = false;
  isVerifying: boolean = false;
  private timerInterval: any;
  time: string = '00:60';
  errorMessageVerify: string = '';
  disableResendButton: boolean = false;
  @ViewChild('count1Input') count1Input: ElementRef;
  @ViewChild('count2Input') count2Input: ElementRef;
  @ViewChild('count3Input') count3Input: ElementRef;
  @ViewChild('count4Input') count4Input: ElementRef;
  @ViewChild('count5Input') count5Input: ElementRef;
  @ViewChild('count6Input') count6Input: ElementRef;

  showPassword = false;
  successPasswordMessage = false;
  successMsgOtpSection: string = '';
  resetPasswordForm: FormGroup;
  isPasswordVisible: boolean = false;
  @ViewChild('passwordInput') passwordInput: ElementRef;
  errorMessage: string;

  constructor(public router: Router,
    private route: ActivatedRoute,
    private formBuilder: FormBuilder,
    public appGlobals: AppGlobals,
    public sharedService: SharedService,
    private authService: AuthService) {
    if (this.authService.isLoggedIn && this.authService.user) {
      this.router.navigate(this.appGlobals.homePath);
    }
  }

  ngOnInit(): void {
    this.createforgotForm();
    this.createOtpForm();
    this.createResetPasswordForm();

    if (this.route.snapshot.params['token'] && this.route.snapshot.params['user'] && this.route.snapshot.params['otp']) {
      this.user = new User(JSON.parse(this.sharedService.decrypt(this.route.snapshot.params['user'])));
      this.token = this.route.snapshot.params['token'];
      this.otp = this.route.snapshot.params['otp'].split('');
      this.forgotFirstStep = false;
      this.otpSectionForm.setValue({
        count1: this.otp?.[0],
        count2: this.otp?.[1],
        count3: this.otp?.[2],
        count4: this.otp?.[3],
        count5: this.otp?.[4],
        count6: this.otp?.[5]
      });
      this.otpSubmit();
    }

    if (this.route.snapshot.params['token'] && this.route.snapshot.params['user']) {
      this.user = new User(JSON.parse(this.sharedService.decrypt(this.route.snapshot.params['user'].replaceAll('&#x2F;', '/'))));
      this.token = this.route.snapshot.params['token'].replaceAll('&#x2F;', '/');
      this.forgotFirstStep = false;
      this.passwordSection = true;
      this.createResetPasswordForm();
    }
  }

  get f() { return this.forgotForm.controls; }
  get verifyf() { return this.otpSectionForm.controls; }
  get resetPass() { return this.resetPasswordForm.controls; }

  /**
  The createforgotForm function is used to create and initialize the forgotForm FormGroup in our application.
    @returns void
  * @author Darshan Malani 10:45 AM 10/30/2023
  * @param 
  */
  createforgotForm() {
    this.forgotForm = this.formBuilder.group({
      username: ['', [Validators.required, Validators.pattern(this.appGlobals.regex['passwordEmail'])]]
    })
  }

  /**
  The createOtpForm function is used to create and initialize the otpSectionForm FormGroup in our application.
    @returns void
  * @author Darshan Malani 10:45 AM 10/30/2023
  * @param 
  */
  createOtpForm() {
    this.otpSectionForm = this.formBuilder.group({
      count1: ['', [Validators.required, this.onlyNumericValidator]],
      count2: ['', [Validators.required, this.onlyNumericValidator]],
      count3: ['', [Validators.required, this.onlyNumericValidator]],
      count4: ['', [Validators.required, this.onlyNumericValidator]],
      count5: ['', [Validators.required, this.onlyNumericValidator]],
      count6: ['', [Validators.required, this.onlyNumericValidator]]
    });
  }

  /**
    The createResetPasswordForm function is used to create and initialize the resetPasswordForm FormGroup in your application. Here's an overview of the function:
      @returns void
    * @author Darshan Malani 10:45 AM 10/30/2023
    * @param 
    */
  createResetPasswordForm() {
    this.resetPasswordForm = this.formBuilder.group({
      password: ['', [Validators.required, Validators.minLength(this.appGlobals.minPasswordLength), Validators.pattern(this.appGlobals.regex['password'])]],
    })
  }

  /**
  The forgotPasswordSubmit function is responsible for submitting the forgot password form in your application
    @returns void
  * @author Darshan Malani 10:45 AM 10/30/2023
  * @param 
  */
  forgotPasswordSubmit() {
    this.isSubmitAttempted = true; // Set the flag to indicate that a Form attempt has been made
    if (this.forgotForm.invalid) {
      this.errorMessageForgotPass = 'Please enter valid credentials.'; // Display an error message if the form is invalid
    } else {
      // If the form is valid, call the userForm method of the authService to submit the Form data
      this.authService.forgotPassword(this.forgotForm.value.username).pipe(first()).subscribe(
        (res: any) => {
          this.user = res.user;
          this.token = res.token;
          this.forgotFirstStep = false;
          this.forgotOtpSection = true;
          this.startTimer();
        },
        (error: any) => {
          this.errorMessageForgotPass = error; // Handle the error response from the backend
          this.successMsgOtpSection = '';
        }
      );
    }
  }

  /**
  The otpSubmit function is responsible for submitting the OTP (one-time password) for verification in your application. 
    @returns void
  * @author Darshan Malani 10:45 AM 10/30/2023
  * @param 
  */
  otpSubmit() {
    if (this.isVerifying) {
      return; // Exit the function if verification is already in progress
    }
    this.startTimer();
    const otp = this.otpSectionForm.value.count1 +
      this.otpSectionForm.value.count2 +
      this.otpSectionForm.value.count3 +
      this.otpSectionForm.value.count4 +
      this.otpSectionForm.value.count5 +
      this.otpSectionForm.value.count6;
    this.isSubmitAttempted = true;
    this.isVerifying = true; // Set isVerifying to true before making the API call
    this.authService.verifyForgotOtp(otp, this.token).pipe(first()).subscribe(
      (res: any) => {
        this.user = res.user;
        this.token = res.token;
        this.isVerifying = false;
        this.forgotOtpSection = false;
        this.passwordSection = true;

      },
      (error: any) => {
        this.successMsgOtpSection = '';
        this.errorMessageVerify = error;
        this.disableButtonOnError = true;
        this.isVerifying = false; // Set isVerifying to false if there is an error in the API call
      }
    );
  }

  /**
  The reSendCodeSubmit function is responsible for resending the OTP (one-time password) for verification in your application.
    @returns void
  * @author Darshan Malani 10:45 AM 10/30/2023
  * @param 
  */
  reSendCodeSubmit(): void {
    this.startTimer();
    this.disableResendButton = true; // Disable the link
    this.authService.reSendForgotOtp(this.token).pipe(first()).subscribe(
      (res: any) => {
        this.token = res.token;
        this.user = res.user;
        this.successMsgOtpSection = res.message;
        this.errorMessageVerify = '';
      },
      (error: any) => {
        this.successMsgOtpSection = '';
        this.errorMessageVerify = error;
      }
    );
  }

  /**
  The resetPasswordSubmit function is responsible for submitting the reset password form in your application. 
    @returns void
  * @author Darshan Malani 10:45 AM 10/30/2023
  * @param 
  */
  resetPasswordSubmit() {
    this.isSubmitAttempted = true; // Set the flag to indicate that a Form attempt has been made
    if (this.resetPasswordForm.invalid) {
      this.errorMessageForgotPass = 'Please enter valid credentials.'; // Display an error message if the form is invalid
    } else {
      this.authService.createNewPassword(this.resetPasswordForm.value.password, this.token).pipe(first()).subscribe(
        (res: any) => {
          this.passwordSection = false;
          this.successPasswordMessage = true;
        },
        (error: any) => {
          this.errorMessageForgotPass = error; // Handle the error response from the backend
          this.successMsgOtpSection = '';

        }
      );
    }
  }

  onlyNumericValidator(control: AbstractControl): { [key: string]: boolean } | null {
    const value = control.value;
    if (value && !/^\d+$/.test(value)) {
      return { numeric: true };
    }
    return null;
  }

  inputFields = [
    { name: 'count1', errorMessages: { required: 'Required.', numeric: 'Only numeric.' } },
    { name: 'count2', errorMessages: { required: 'Required.', numeric: 'Only numeric.' } },
    { name: 'count3', errorMessages: { required: 'Required.', numeric: 'Only numeric.' } },
    { name: 'count4', errorMessages: { required: 'Required.', numeric: 'Only numeric.' } },
    { name: 'count5', errorMessages: { required: 'Required.', numeric: 'Only numeric.' } },
    { name: 'count6', errorMessages: { required: 'Required.', numeric: 'Only numeric.' } }
  ];

  onInputChange(): void {
    this.disableButtonOnError = false; // Enable the button when input changes
    const hasRequiredError = this.inputFields.some(field => {
      const control = this.verifyf[field.name];
      return control.invalid && control.touched && control.errors.required;
    });

    this.errorMessage = hasRequiredError ? 'Required.' : '';
  }

  startTimer(): void {
    this.stopTimer(); // Stop the timer if it's already running
    //const totalSeconds = 30; // Total seconds (30 seconds)
    let seconds = this.appGlobals.timer;
    // Update the time initially
    this.updateTimeDisplay(seconds);
    // Start the timer interval
    this.timerInterval = setInterval(() => {
      if (seconds > 0) {
        seconds--;
        this.updateTimeDisplay(seconds);
        this.disableResendButton = seconds < 30; // Enable the button if seconds is less than 30

      } else {
        this.stopTimer(); // Stop the timer when it reaches 0
        this.disableResendButton = false; // Enable the button after the timer reaches 0
      }
    }, 1000);
  }

  stopTimer() {
    if (this.timerInterval) {
      clearInterval(this.timerInterval);
      this.timerInterval = null;
    }
  }

  updateTimeDisplay(seconds: number): void {
    const remainingSeconds = seconds % 60;
    this.time = `00:${remainingSeconds.toString().padStart(2, '0')}`;
  }

  moveFocus(currentInput: HTMLInputElement, nextInput: HTMLInputElement, previousInput: HTMLInputElement): void {
    if (currentInput.value && currentInput.value.length === currentInput.maxLength) {
      nextInput.focus();
    } else {
      previousInput.focus();
    }

  }

  togglePasswordVisibility() {
    this.isPasswordVisible = !this.isPasswordVisible; // Toggle the visibility flag
    this.passwordInput.nativeElement.focus(); // Set focus on the password input field
  }

  isRequirementMet(requirement: RegExp): boolean {
    const passwordControl = this.resetPasswordForm.get('password');
    const pattern = new RegExp(requirement);
    return passwordControl.value && pattern.test(passwordControl.value);
  }
}